import { VesselSchedulePage } from "./VesselSchedulePage";
import { ConsolidatedVesselSchedulePage } from "./ConsolidatedVesselSchedulePage";
import { ShippingReportPage } from "./ShippingReportPage";

const DashboardAppConfig = {
  pages: {
    /*         'VesselSchedule': {
            name: 'Vessel Schedule',
            component: <VesselSchedulePage />,
            url: 'VesselSchedule',
            image: '/resources/VesselSchedule.jpg',
        },
        'ConsolidatedVesselSchedule': {
            name: 'Consolidated Vessel Schedule',
            component: <ConsolidatedVesselSchedulePage />,
            url: 'ConsolidatedVesselSchedule',
            image: '/resources/ConsolidatedVesselSchedule.jpg',
        }, */
    ShippingReport: {
      name: "Shipping Report",
      component: <ShippingReportPage />,
      url: "ShippingReport",
      image: "/resources/ConsolidatedVesselSchedule.jpg",
      auth: ["LP_Management", "LP_Admin"],
    },
  },
};

export { DashboardAppConfig };
